import { ThemeType } from 'theme/jss-types';
import { commonStyleSheet } from '../../library/common-styles';

const common = {
    trackingTitle: {
        fontSize: 14,
        fontWeight: 600,
        color: '#232529',
        fontFamily: 'Open Sans',
        letterSpacing: 0,
    },
    trackingHeader: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    hr: {
        width: '98%',
        height: 1,
        backgroundColor: '#CCCCCC',
        marginTop: 4,
    },
};
export const consignmentDetailedStyles = (theme: ThemeType) => ({
    ...commonStyleSheet(theme),
    ...common,
    arrowIcon: {
        marginRight: 8,
    },
    backText: {
        color: '#333333',
        fontFamily: 'Open Sans',
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: 0,
        padding: '16px 0px',
        cursor: 'pointer',
    },
    address: {
        width: '49.85%',
        height: 200,
        padding: '16px 16px',
        backgroundColor: '#FFFFFF',
    },
    addresses: {
        ...commonStyleSheet(theme).flexRow,
        width: '100%',
        justifyContent: 'space-between',
        padding: '2px 0px',
    },
    referenceBox: {
        borderRadius: '0 2px 0 0',
        backgroundColor: '#FFFBE9',
        padding: 16,
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    referenceValue: {
        color: '#111111',
        fontFamily: 'Open Sans',
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: 0,
    },
    referenceName: {
        color: '#666666',
        fontSize: 10,
        letterSpacing: 0,
        fontFamily: 'Open Sans',
    },
    detailsBox: {
        display: 'flex',
        width: '100%',
        marginTop: 2,
        justifyContent: 'space-between',
    },
    trackingBox: {
        backgroundColor: '#FFFFFF',
        padding: '12px 16px',
        borderRight: '1px solid #dddfe9',
        height: '100%',
    },
    consignmentDetails: {
        width: '54.8%',
    },
    serviceDetails: {
        width: '100%',
        backgroundColor: '#FFFFFF',
        padding: '16px 16px',
        minHeight: '30vh',
    },
    itemsList: {
        marginTop: 20,
        width: '100%',
    },
    keyValuePair: {
        width: '30%',
        ...commonStyleSheet(theme).flexRow,
        marginBottom: 8,
    },
    itemType: {
        width: '50%',
        ...commonStyleSheet(theme).flexRow,
        marginBottom: 8,
    },
    itemKey: {
        color: '#333333',
        fontFamily: 'Open Sans',
        fontSize: 12,
        letterSpacing: 0,
        width: '30%',
    },
    pairKey: {
        color: '#333333',
        fontFamily: 'Open Sans',
        fontSize: 12,
        letterSpacing: 0,
        width: '50%',
    },
    pairValue: {
        color: '#111111',
        fontFamily: 'Open Sans',
        fontWeight: 600,
        fontSize: 12,
        letterSpacing: 0,
        width: '50%',
    },
    addresDetails: {
        color: '#111111',
        fontFamily: 'Open Sans',
        fontWeight: 600,
        letterSpacing: 0,
        ...commonStyleSheet(theme).flexColumn,
    },
    addressTitle: {
        fontSize: 14,
        marginTop: 16,
        fontWeight: 600,
    },
    addressValue: {
        fontSize: 12,
        marginTop: 8,
        fontWeight: 600,
    },
    mainPage: {
        width: '100%',
        fontFamily: 'Open Sans',
        backgroundColor: '#ffffff',
        overflow: 'auto',
        height: '100%',
    },
    mainDrawer: {
        width: '100%',
        '& .ant-drawer-body': {
            padding: 0,
            overflow: 'auto',
            height: '100%',
        },
        '& .ant-drawer-header': {
            padding: 10,
        },
        '& .ant-drawer-content': {
            height: '100%',
        },
        '& .ant-drawer-wrapper-body': {
            height: '100%',
            overflow: 'hidden',
        },
    },
    body: {
        padding: 24,
        paddingBottom: 8,
        width: '100%',
    },
    hr: {
        width: '100%',
        height: 1,
        backgroundColor: '#CCCCCC',
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        padding: 0,
        justifyContent: 'space-between',
        marginLeft: '6px',
    },
    pageHeader: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        padding: '12px 16px',
        justifyContent: 'space-between',
        borderBottom: '1px solid #0F1E371A',
    },
    closeIcon: {
        fontSize: 16,
        cursor: 'pointer',
        color: '#CCC',
    },
    expandIcon: {
        fontSize: 22,
        cursor: 'pointer',
        color: '#777777',
        backgroundColor: '#F7F7F7',
        borderRadius: '4px',
        padding: '2px',
    },
    printerIcon: {
        fontSize: 22,
        marginRight: '8px',
        '& .anticon': {
            color: '#333333',
        },
        padding: '8px',
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 24,
    },
    moreFilter: {
        marginLeft: 16,
        fontWeight: 600,
        fontSize: 12,
        cursor: 'pointer',
        color: theme.primaryColor,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    labelClass: {
        color: '#333333',
        fontFamily: 'Open Sans',
        fontSize: 12,
        letterSpacing: 0,
        width: 120,
    },
    resetFilter: {
        color: '#DF1D1D',
        fontSize: 12,
        fontWeight: 600,
        cursor: 'pointer',
    },
    footer: {
        position: 'absolute',
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e8e8e8',
        padding: '10px 16px',
        textAlign: 'left',
        left: 0,
        background: '#fff',
        borderRadius: '0 0 4px 4px',
        height: 56,
    },
    bodyContainer: {
        display: 'flex',
        width: '100%',
        overflow: 'visible',
    },
    leftColumn: {
        backgroundColor: '#f0f0f0',
        width: '30%',
        overflow: 'auto',
        position: 'relative',
    },
    rightColumn: {
        backgroundColor: '#ffffff',
        width: '70%',
        overflow: 'auto',
    },
    quickDetails: {
        display: 'flex',
        padding: '32px 16px 32px 16px',
        backgroundColor: '#FFFFFF',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
    },
    eddDates: {
        marginRight: '8px',
        padding: '4px 8px',
        borderRadius: 4,
        // backgroundColor: '#F7F7F7',
        // color: '#777777',
        backgroundColor: 'rgba(0, 96, 209, 0.1)',
        color: '#0060d1',
        fontSize: 12,
        fontWeight: 600,
        fontFamily: 'Open Sans',
    },
    eddValue: {
        marginLeft: 4,
    },
    quickDetailsItem: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        alignItems: 'center',
        gap: '6px',
    },
    quickDetailsLabel: {
        fontWeight: 600,
        size: 12,
        font: 'Open Sans',
        lineHeight: '16px',
        textAlign: 'center',
        marginRight: '4px',
    },
    quickDetailsValue: {
        fontWeight: 600,
        size: 16,
        font: 'Open Sans',
        color: '#232529',
    },
    verticalDash: {
        width: '32px',
        height: '1px',
        border: '1px solid #DDDFE9',
        transform: 'rotate(-90deg)',
    },
    addressSection: {
        marginBottom: 16,
    },
    availableText: {
        color: '#111111',
        fontFamily: 'Open Sans',
        fontSize: 11,
        letterSpacing: 0,
    },
    trackText: {
        ...commonStyleSheet(theme).flexRow,
        justifyContent: 'flex-start',
    },
    eddDescription: {
        marginRight: '4px',
        cursor: 'pointer',
    },
    referenceText: {
    },
    consignmentHeader: {
        fontSize: 18,
        fontWeight: 600,
        color: '#232529',
        fontFamily: 'Open Sans',
    },
    consignmentServiceType: {
        padding: '4px 8px',
        borderRadius: 4,
        backgroundColor: '#F7F7F7',
        fontSize: 12,
        fontWeight: 600,
        color: '#777777',
        fontFamily: 'Open Sans',
    },
    consignmentStatus: {
        padding: '4px 8px',
        borderRadius: 12,
        backgroundColor: 'rgba(0, 96, 209, 0.1)',
        color: '#0060d1',
        fontSize: 12,
        fontWeight: 600,
        fontFamily: 'Open Sans',
    },
    paymentMode: {
        padding: '4px 8px',
        borderRadius: 16,
        backgroundColor: '#EDF8F1',
        fontSize: 12,
        fontWeight: 600,
        color: '#5CAF7E',
        fontFamily: 'Open Sans',
    },
    tabsContainer: {
        boxShadow: '1px 2px 3px 0px rgb(0,0,0,0.1)',
        '& .ant-tabs-nav-list': {
            backgroundColor: '#FFFFFF',
            borderBottom: '1px solid #f0f0f0',
            minHeight: 42,
        },
        // eslint-disable-next-line max-len
        '& .ant-tabs-top > .ant-tabs-nav, .ant-tabs-bottom > .ant-tabs-nav, .ant-tabs-top > div > .ant-tabs-nav, .ant-tabs-bottom > div > .ant-tabs-nav': {
            margin: 0,
            border: 'none',
        },
        '& .ant-tabs-tab': {
            color: '#909090',
            fontWeight: 600,
            fontFamily: 'Open Sans',
            fontSize: 14,
            letterSpacing: 0,
            padding: '2px 18px !important',
            borderRadius: '4px 4px 0 0',
            border: 'none',
            backgroundColor: '#FFFFFF !important',
            cursor: 'pointer',
        },
        '& .ant-tabs-tab + .ant-tabs-tab': {
            margin: 0,
        },
    },
    bucketRow: {
        '& .ant-tabs-nav-operations': {
            padding: 4,
            width: 'auto',
            fontSize: 18,
            backgroundColor: '#f8f8ff',
        },
        '& .ant-tabs-nav-operations::after': {
            display: 'none !important',
            content: 'none !important',
        },
    },
});

export const consignmentDetailsIntStyles = (theme: ThemeType) => ({
    ...consignmentDetailedStyles(theme),
    ...common,
    mainDiv: {
        width: '100%',
        overflow: 'auto',
        backgroundColor: '#ffffff',
    },
    bucket: {
        color: '#666666',
        fontFamily: 'Open Sans',
        fontSize: 14,
        letterSpacing: 0,
        padding: '6px 10px',
        marginRight: 2,
        borderRadius: '4px 4px 0 0',
        backgroundColor: '#F5F5F5',
        display: 'flex',
        cursor: 'pointer',
    },
    bucketSelected: {
        color: '#111111',
        fontWeight: 'bold',
        backgroundColor: '#FFF',
    },
    buckets: {
        ...commonStyleSheet(theme).flexRow,
        marginBottom: 16,
    },
    tabDetails: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'start',
    },
    fieldGroup: {
        display: 'flex',
        flexWrap: 'wrap',
        overflowWrap: 'break-word',
        alignItems: 'start',
        fontSize: 12,
        width: '50%',
    },
    fieldGroupMobile: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        overflowWrap: 'break-word',
        alignItems: 'start',
        fontSize: 12,
        width: '50%',
    },
    fieldTitle: {
        fontFamily: 'Open Sans',
        fontWeight: 600,
        fontSize: 12,
        lineHeight: '12px',
        padding: '4px',
        color: '#232529',
    },
    fieldTitleMobile: {
        fontFamily: 'Open Sans',
        fontSize: 12,
        lineHeight: '12px',
        padding: '4px 0',
        color: '#999',
    },
    fieldValue: {
        fontFamily: 'Open Sans',
        fontWeight: 400,
        fontSize: 12,
        paddingLeft: '4px',
        color: '#232529',
    },
    fieldValueMobile: {
        fontFamily: 'Open Sans',
        fontWeight: 700,
        fontSize: 14,
    },
    box: {
        borderRadius: 4,
        margin: 16,
        backgroundColor: '#FAFAFA',
        width: '100%',
    },
    boxTitle: {
        fontWeight: 'bold',
    },
    documentGroup: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '50%',
    },
    documentGroupMobile: {
        display: 'flex',
        flexDirection: 'column',
        width: '50%',
    },
    detailsTabMobile: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    detailsTab: {
        display: 'flex',
        flexDirection: 'column',
        padding: '16px 16px',
        backgroundColor: '#FFFFFF',
        width: '100%',
        overflow: 'visible',
        height: 'auto',
    },
    sectionHeading: {
        fontFamily: 'Open Sans',
        fontWeight: 600,
        fontSize: 11,
        lineHeight: '12px',
        padding: '4px 8px',
        color: '#777777',
        marginBottom: '8px',
    },
    sectionHeadingMobile: {
        fontFamily: 'Open Sans',
        fontWeight: 700,
        fontSize: 16,
        marginBottom: '8px',
    },
    sectionBox: {
        padding: '10px',
        marginBottom: '10px',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'start',
    },
    sectionBoxMobile: {
        marginBottom: '16px',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'start',
        rowGap: '10px',
    },
    pieceDetailsTab: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'start',
        height: '100%',
    },
    pieceDetailsTabLeft: {
        padding: '12px',
        width: '35%',
        height: '100%',
        borderRight: '1px solid #dddfe9',
        overflowY: 'auto',
    },
    pieceDetailsTabRight: {
        width: '65%',
        height: '100%',
        overflowY: 'auto',
    },
    piecesNumber: {
        border: '1px solid #e7e8eb',
        borderRadius: '4px',
        padding: '4px 8px',
        gap: '8px',
        fontFamily: 'Open Sans',
        fontWeight: 700,
        fontSize: 10,
        color: '#333333',
        marginLeft: '8px',
    },
    pieceCard: {
        backgroundColor: '#fcfcfc',
        border: '1px solid #dddfe9',
        padding: '12px',
        borderRadius: '12px',
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '10px',
        cursor: 'pointer',
    },
    pieceCardColumnHeader: {
        fontFamily: 'Open Sans',
        fontSize: 12,
        fontWeight: 600,
        color: '#777777',
        padding: '10px',
    },
    pieceCardUpper: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    pieceCardSCNS: {
        display: 'flex',
        flexDirection: 'column',
    },
    pieceCardStatus: {
        padding: '4px',
        borderRadius: '4px',
        background: '#e5effa',
        color: '#0060d1',
        fontFamily: 'Open Sans',
        fontSize: 10,
        fontWeight: 500,
        width: 'fit-content',
    },
    pieceCardStatusLine: {
        display: 'flex',
        gap: '5px',
    },
    pieceCardLeft: {
        display: 'flex',
        flexDirection: 'column',
    },
    pieceCardRight: {
        display: 'flex',
        textAlign: 'right',
        flexDirection: 'column',
    },
    pieceHeader: {
        fontFamily: 'Open Sans',
        fontSize: 14,
        fontWeight: 700,
        color: '#232529',
    },
    pieceDimensions: {
        fontFamily: 'Open Sans',
        fontSize: 12,
        fontWeight: 600,
        color: '#232529',
        marginTop: '6px',
    },
    pieceDescription: {
        fontFamily: 'Open Sans',
        fontSize: 12,
        fontWeight: 400,
        color: '#909090',
    },
    documentViewButton: {
        fontFamily: 'Open Sans',
        fontWeight: 700,
        fontSize: 11,
        lineHeight: '12px',
        padding: '0px',
        color: '#006ec3',
        height: '10px',
    },
    itemDetailsTab: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#f7f7f7',
        padding: '10px',
        '& .ant-collapse-header': {
            fontFamily: 'Open Sans',
            fontWeight: 700,
            fontSize: 14,
            color: '#232529',
            padding: '4px 8px',
        },
        '& .ant-collapse-arrow': {
            width: '12px',
            height: '6px',
            color: '#777777',
        },
    },
    itemSectionBox: {
        marginBottom: '10px',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'start',
    },
    addressBox: {
        borderRadius: 6,
        padding: '12px',
        backgroundColor: '#ffffff',
        border: '0.5px solid #dddfe9',
        boxSizing: 'border-box',
    },
    addressInfoUpper: {
        padding: '12px',
        display: 'flex',
        justifyContent: 'space-between',
    },
    addressInfoLower: {
        padding: '8px 4px',
        display: 'flex',
        flexDirection: 'column',
    },
    addressInfoUpperLeft: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'left',
    },
    addressInfoUpperRight: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'right',
    },
    addressVerticalJoin: {
        height: '8px',
        marginLeft: '14px',
        width: '1px',
        backgroundColor: '#dddfe9',
    },
    verticalSpace: {
        height: '4px',
        marginLeft: '14px',
        width: '1px',
    },
    addressType: {
        fontFamily: 'Open Sans',
        fontSize: 12,
        fontWeight: 600,
        color: '#777777',
    },
    addressPincode: {
        fontFamily: 'Open Sans',
        fontSize: 14,
        fontWeight: 600,
        color: '#232529',
    },
    addressCSC: {
        fontFamily: 'Open Sans',
        fontSize: 14,
        fontWeight: 400,
        color: '#232529',
        marginLeft: '4px',
    },
    addressName: {
        fontFamily: 'Open Sans',
        fontSize: 14,
        fontWeight: 600,
        color: '#232529',
    },
    addressContact: {
        fontFamily: 'Open Sans',
        fontSize: 12,
        fontWeight: 400,
        color: '#232529',
    },
    addressDetails: {
        padding: '16px',
        display: 'flex',
        flexDirection: 'column',
    },
    addressServiceTimeBox: {
        padding: '4px 8px',
        textAlign: 'right',
        fontFamily: 'Open Sans',
        fontWeight: '400',
        fontSize: 14,
    },
    horizontalSeperator: {
        width: '97%',
        margin: '2px',
        border: '1px solid #0F1E371A',
    },
});

export const courierTrackingStyles = (theme: ThemeType) => ({
    ...common,
    mainDiv: {
        width: '100%',
        paddingTop: 0,
        maxHeight: '75vh',
        overflow: 'scroll',
    },
    referenceNumber: {
        fontSize: '18px',
        fontWeight: 'bold',
        marginTop: '5px',
        width: '10%',
        color: '#444444',
        fontFamily: 'Open Sans',
    },
    header: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'top',
        height: '85px',
        padding: 16,
    },
    flexColumn: {
        display: 'flex',
        flexDirection: 'column',
        width: '13%',
        marginTop: 8,
    },
    title: {
        color: '#666666',
        lineHeight: '14px',
        marginLeft: 12,
        fontSize: 12,
    },
    value: {
        color: '#111111',
        marginLeft: 12,
        fontSize: 12,
        lineHeight: '14px',
        fontWeight: 600,
    },
    na: {
        color: '#999999',
        fontSize: 14,
        fontWeight: 600,
        letterSpacing: 0,
        lineHeight: '12px',
        width: '50%',
        marginLeft: 16,
    },
    trackingBox: {
        width: '100%',
        marginTop: 10,
        backgroundColor: '#FFFFFF',
        borderRadius: 5,
        marginBottom: 50,
        justifyItems: 'center',
    },
    dot: {
        color: '#27B479',
        fontSize: 24,
    },
    timelineItem: {
        width: '6%',
        height: 90,
        marginTop: 6,
        '& .ant-timeline-item-tail': {
            borderLeft: '2px solid #D9D9D9',
            height: '100%',
        },
        '& .ant-timeline-item-head-custom': {
            padding: '0px 1px',
            top: 8,
            borderRadius: '100px',
        },
    },
    lineItemNoTail: {
        width: '6%',
        height: 90,
        marginTop: 6,
        '& .ant-timeline-item-tail': {
            display: 'none',
        },
        '& .ant-timeline-item-head-custom': {
            padding: '0px 1px',
            top: 8,
            borderRadius: '100px',
        },
    },
    timeline: {
        padding: '16px',
    },
    flexRow: {
        display: 'flex',
        flexDirection: 'row',
    },
    lineItemLeft: {
        display: 'flex',
        flexDirection: 'column',
    },
    lineItemRight: {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: 6,
        width: '60%',
    },
    dateTimeline: {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: 12,
    },
    eventTimeline: {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: 11,
        width: '60%',
    },
    date: {
        fontSize: 11,
        fontWeight: 650,
        color: '#666666',
        fontFamily: 'Open Sans',
        alignSelf: 'flex-start',
        width: 'max-content',
    },
    time: {
        fontSize: 10,
        fontWeight: 600,
        color: '#666666',
        fontFamily: 'Open Sans',
        alignSelf: 'flex-start',
    },
    eventName: {
        fontSize: 12,
        fontWeight: 600,
        color: '#232529',
        fontFamily: 'Open Sans',
        alignSelf: 'flex-start',
    },
    eventLocation: {
        fontSize: 12,
        fontWeight: 400,
        color: '#909090',
        fontFamily: 'Open Sans',
    },
    textRight: {
        fontSize: 14,
        fontWeight: 'bold',
        color: '#444444',
        fontFamily: 'Open Sans',
        alignSelf: 'flex-start',
    },
    locationRight: {
        fontSize: 12,
        color: '#666666',
        fontFamily: 'Open Sans',
    },
    reference: {
        ...commonStyleSheet(theme).flexRow,
        padding: 12,
        border: '1px solid #FAF6EF',
        borderRadius: '0 4px 4px 0',
        backgroundColor: '#FCFAF4',
        boxShadow: '2px 2px 6px 0 rgba(0,0,0,0.05)',
        justifyContent: 'space-between',
    },
    availableText: {
        color: '#111111',
        fontFamily: 'Open Sans',
        fontSize: 11,
        letterSpacing: 0,
    },
    trackText: {
        ...commonStyleSheet(theme).flexRow,
        justifyContent: 'flex-start',
    },
    referenceText: {
        color: '#111111',
        fontFamily: 'Open Sans',
        fontSize: 13,
        fontWeight: 600,
        letterSpacing: 0,
        marginLeft: 8,
        marginRight: 16,
    },
    referenceValue: {
        fontSize: 14,
        color: '#111111',
        fontWeight: 600,
    },
    referenceTitle: {
        fontSize: 10,
        color: '#666666',
    },
    referenceList: {
    },
    eddDescription: {
        marginLeft: '7px',
        cursor: 'pointer',
    },
    box: {
        backgroundColor: '#fff',
        borderRadius: 15,
        padding: 15,
        marginLeft: 5,
    },
});
